import { render, staticRenderFns } from "./update-package.vue?vue&type=template&id=5e18d6e8&scoped=true"
import script from "./update-package.vue?vue&type=script&lang=js"
export * from "./update-package.vue?vue&type=script&lang=js"
import style0 from "./update-package.vue?vue&type=style&index=0&id=5e18d6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e18d6e8",
  null
  
)

export default component.exports